import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoModelsLicenseCreateResponse,
  useFormSubmit,
} from "melco-shared-logic";
//import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { DisplayUpgradeLicenseVersionAndLevel } from "./DisplayUpgradeLicenseVersionAndLevel";
import { useLicenseManagerUpgrade } from "../../../../hooks/licensemanager/useLicenseManagerUpgrade";
import { useState } from "react";
import { UpgradeLicenseFormValueType } from "./UpgradeLicenseForm";

type UpgradeLicenseVersionAndLevelProps = {
  callbackFn: (obj: any) => void;
  stepback: () => void;
  currentLicense: ControlcenterMelcoModelsLicenseCreateResponse | undefined;
  licenseFormValues: UpgradeLicenseFormValueType | undefined;
};

export const UpgradeLicenseVersionAndLevel: React.FC<
  UpgradeLicenseVersionAndLevelProps
> = ({ currentLicense, stepback, callbackFn, licenseFormValues }) => {
  const queryClient = useQueryClient();
  const queryKey = "upgrade-querylicensemanage";
  const initialValues = {
    version_id: "",
    subscription_code: "",
  };
  //const { t } = useTranslation();

  const upgradeLicenseAndSendEmail = useLicenseManagerUpgrade();

  const [displayValues, setDisplayValues] = useState({
    new_version_id_display_value: "",
    new_subscription_code_display_value: "",
  });

  const callBackForVersionDisplayValue = (v: string) => {
    setDisplayValues({
      ...displayValues,
      new_version_id_display_value: v,
    });
  };
  const callBackForSubscriptionCodeDisplayValue = (v: string) => {
    setDisplayValues({
      ...displayValues,
      new_subscription_code_display_value: v,
    });
  };

  const handleUpgradeLicense = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)

    let newEntity = await upgradeLicenseAndSendEmail({
      email_address: currentLicense?.email_address ?? "",
      step: 2,
      serial_number: currentLicense?.serial_number ?? "",
      version_id: values.version_id,
      subscription_code: values.subscription_code,
      assign_license: !licenseFormValues?.assign_license,
      melco_customer_id: currentLicense?.melco_customer_id,
      language: currentLicense?.language,
    });

    //   //console.log("newEntity",newEntity)
    console.log(newEntity);
    queryClient.setQueryData(queryKey, newEntity);

    callbackFn({
      new_version_id: values.version_id,
      new_subscription_code: values.subscription_code,
      new_version_id_display_value: displayValues.new_version_id_display_value,
      new_subscription_code_display_value:
        displayValues.new_subscription_code_display_value,
    });
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    await onUpgradeSerialNumber(values, formikHelpers, {});
  };

  const formSubmitToUpgradeLicense = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        return handleUpgradeLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.Upgrade",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licensemanager", "upgrade"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onUpgradeSerialNumber = useFormSubmit(...formSubmitToUpgradeLicense());

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <div>
          <DirtyFormPrompt>
            <DisplayUpgradeLicenseVersionAndLevel
              currentLicense={currentLicense}
              stepback={stepback}
              callBackForVersionDisplayValue={callBackForVersionDisplayValue}
              callBackForSubscriptionCodeDisplayValue={
                callBackForSubscriptionCodeDisplayValue
              }
              licenseFormValues={licenseFormValues}
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
